module.exports = __webpack_public_path__ + "img/pic_create_en.6dcaf769.png";